import React from 'react';
import { Shield, LayoutDashboard, Home, LogOut, Settings } from 'lucide-react';

// [수정] onAdminClick과 isAdminMode를 받아오도록 추가했습니다.
export default function Header({ user, userData, setView, onLogout, onHome, onAdminClick, isAdminMode }) {
  return (
    <header className="bg-slate-800 border-b border-slate-700 p-4 sticky top-0 z-50 shadow-lg">
      <div className="max-w-4xl mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition" onClick={onHome}>
          <Shield className="h-6 w-6 text-indigo-400" />
          <h1 className="text-xl font-bold tracking-tight text-slate-100">도승하평가사 암기연습</h1>
        </div>
        
        {user && userData && (
          <div className="flex items-center space-x-2 md:space-x-4">
            <div className="hidden sm:flex flex-col text-right">
              <span className="text-sm font-bold text-indigo-300">{userData.name}님</span>
              <span className="text-xs text-slate-400">합격까지 함께합니다</span>
            </div>

            {/* ▼▼▼ 관리자 전환 버튼 추가 ▼▼▼ */}
            {user?.email === 'doseungha@gmail.com' && !isAdminMode && (
              <button 
                onClick={onAdminClick} 
                className="flex items-center px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition shadow-md border border-red-500 animate-pulse"
                title="관리자 전환"
              >
                <Settings className="h-4 w-4 md:mr-1.5" />
                <span className="text-xs font-bold hidden md:inline">관리자 전환</span>
              </button>
            )}
            {/* ▲▲▲ 관리자 전환 버튼 끝 ▲▲▲ */}

            <button onClick={() => setView('dashboard')} className="p-2 hover:bg-slate-700 rounded-lg text-slate-300 hover:text-white transition" title="대시보드">
              <LayoutDashboard className="h-5 w-5" />
            </button>
            
            <button onClick={onHome} className="p-2 hover:bg-slate-700 rounded-lg text-slate-300 hover:text-white transition flex items-center" title="처음으로">
              <Home className="h-5 w-5 md:mr-1" />
              <span className="text-xs font-bold hidden md:inline">처음으로</span>
            </button>
            
            <button onClick={onLogout} className="p-2 hover:bg-red-900/50 rounded-lg text-red-300 hover:text-red-100 transition flex items-center border border-transparent hover:border-red-500/30" title="로그아웃">
              <LogOut className="h-5 w-5" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}